// Екранната клавиатура под „Сума дадена от клиента" в „Закрий" (бакшишът и
// рестото): разпъната/свита — изборът е на КОМПЮТЪРА, като темата: пази се в
// localStorage под ключ с името на ресторанта (`close_keypad_open:<ресторант>`;
// на localhost всички ресторанти делят един localStorage). Без запис — свита.
// Без хранилище (частен прозорец, забранено) клавиатурата работи, само не помни.
import { useState } from "react";
import { getRestaurantName } from "../../../../../lib/restaurant";
import { sanitizeMoneyInput } from "../../../../../utils/money";

/** Натиснатият клавиш: цифра, десетичната точка или „изтрий знак". */
export type MoneyKeypadKey = "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "." | "backspace";

/** Текстът в полето след клавиша — като писане в него (до 2 знака след точката). */
export const keypadTextOf = (text: string, key: MoneyKeypadKey): string =>
  sanitizeMoneyInput(key === "backspace" ? text.slice(0, -1) : text + key);

const keypadOpenKey = () => `close_keypad_open:${getRestaurantName()}`;

const readKeypadOpen = (): boolean => {
  try {
    return localStorage.getItem(keypadOpenKey()) === "1";
  } catch {
    return false;
  }
};

const writeKeypadOpen = (open: boolean) => {
  try {
    localStorage.setItem(keypadOpenKey(), open ? "1" : "0");
  } catch {
    // пълно/забранено хранилище — изборът важи до затварянето на модала
  }
};

export function useKeypadOpen() {
  const [isOpen, setIsOpen] = useState(readKeypadOpen);
  const toggle = () => {
    const next = !isOpen;
    setIsOpen(next);
    writeKeypadOpen(next);
  };
  return { isOpen, toggle };
}
